module.exports = __webpack_public_path__ + "media/images/emblems/Buseno_wappen-e24b983d74be5dfd806613d0088c090e.svg";